<template>
    <div class="header-mobile">
        <div class="logo" @click="goToHome">
            <img src="../../../assets/images/logoMonPermis.png" alt="monpermis.fr">
        </div>
        <div class="title">
            <h1>{{page}}</h1>
        </div>
        <div class="user">
            <span class="userinfo">Bonjour</span>
            <span class="userinfo">{{user}}</span>
            <span class="disconect" @click="deconnexion">se déconnecter</span>
        </div>
    </div>
</template>
<script>
export default {
    props: ["page", "user"],

    methods: {
        deconnexion() {
            if (this.$store.state.user && this.$store.state.user.id) {
                sessionStorage.removeItem('rdvPrealablePopupShown_' + this.$store.state.user.id);
            }
            this.$store.commit("setUser", null);
            this.$store.commit("setToken", null);
            localStorage.removeItem("user_info");
            localStorage.removeItem("user_access");
            this.$router.push({name: 'index'});
        },

        goToHome(){
            this.$router.push({ name: "Home" });
        }

    },
}
</script>
<style scoped>

    div.header-mobile{
        border-bottom: 1px solid #D2D9E0;
        width: 95%;
        margin: auto;
        height: 100%;
        max-height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
    }

    div.header-mobile div.logo img{
        width: 40px;
        height: 40px;
    }

    div.header-mobile h1{
        color: #2E9EA3;
        font-weight: bold;
        position: absolute;
        left: 50%;
        top: 20%;
        transform: translateX(-50%);
    }

    div.header-mobile div.user{
        text-align: right;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        line-height: 1;
    }

    div.header-mobile div.user span.disconect{
        font-size: 10px;
        color: gray;
        cursor: pointer;
    }

    div.header-mobile div.user span.userinfo{
        font-weight: bold;
    }


</style>